var _defs, _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _rect2, _rect3, _rect4, _path8, _rect5, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvertisments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 169.02 127.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.67,59.7v22.17c0,2.79-2.25,5.06-5.05,5.06h-11.5c-.62.67-1.36,1.21-2.04,1.48-3.06,1.2-6.25,2.15-9.32,3.06l-1.31.39c-1.09.33-2.08.5-3,.5-2.37,0-4.23-1.12-5.92-3.47-.47-.65-.93-1.3-1.4-1.95H9.72c-2.79,0-5.06-2.26-5.06-5.06V19.23c0-2.79,2.26-5.05,5.06-5.05h96.74c.96-.71,1.89-1.43,2.82-2.17,1.35-1.09,2.69-2.24,4-3.42H8.21C3.68,8.59,0,12.27,0,16.8v75.89c0,4.53,3.68,8.21,8.21,8.21h117.85c4.54,0,8.21-3.67,8.21-8.2v-32.22c-1.86-.3-3.73-.56-5.59-.78Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.56,103.7c-.04,3.54-1.62,6.93-3.73,10.26h48.49c-1.97-2.88-3.22-6.3-3.73-10.26h-41.03Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.04,
    y: 117.68,
    width: 82.98,
    height: 10.26,
    rx: 3.02,
    ry: 3.02
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.17,78.21v2.25c0,.76-.51,1.37-1.13,1.37H10.61c-.62,0-1.13-.61-1.13-1.37v-2.25c0-.75.51-1.37,1.13-1.37h49.43c.62,0,1.13.61,1.13,1.37Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.17,69.55v2.25c0,.76-.51,1.37-1.13,1.37H10.61c-.62,0-1.13-.61-1.13-1.37v-2.25c0-.75.51-1.37,1.13-1.37h49.43c.62,0,1.13.61,1.13,1.37Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.17,60.88v2.25c0,.76-.51,1.37-1.13,1.37H10.61c-.62,0-1.13-.61-1.13-1.37v-2.25c0-.75.51-1.37,1.13-1.37h49.43c.62,0,1.13.61,1.13,1.37Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.52,56.75c.48,1.54-.37,3.17-1.9,3.66-.48.15-.96.31-1.44.46-.1.03-.19.06-.29.09-2.74.88-5.4,1.73-8.05,2.43-1.63.43-3.26.81-4.91,1.1-1.89.33-3.79.23-5.6-.24-4.97-1.28-8.38-5.21-10.79-10.21-.43-.88-.54-1.24-.73-1.8-2.01-5.82,1.93-14.69,8.75-17.33,2.04-.79,4.1-1.47,6.18-2.16,2.04-.67,4.11-1.33,6.24-2.01.38-.12.77-.25,1.15-.37,1.54-.49,3.19.36,3.67,1.9l.15.48.96,3.04,1.3,4.12.8,2.53,1.3,4.12.96,3.04,1.3,4.12.96,3.04h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.5,67.52h-.42l.35-.11s.05.08.08.11Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.48,
    y: 48.42,
    width: 20,
    height: 5.29,
    rx: 2.21,
    ry: 2.21
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.48,
    y: 39.22,
    width: 20,
    height: 5.29,
    rx: 2.21,
    ry: 2.21
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.48,
    y: 30.68,
    width: 20,
    height: 5.29,
    rx: 2.21,
    ry: 2.21
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.17,22.61v12.89c-5.4,2.59-9.15,13.39-4.9,18.13h-22.14c-.62,0-1.13-.51-1.13-1.13v-29.89c0-.62.51-1.13,1.13-1.13h25.92c.62,0,1.13.51,1.13,1.13Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.48,
    y: 21.48,
    width: 20,
    height: 5.29,
    rx: 2.21,
    ry: 2.21
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169.02,29.23v2.86c0,.15-.02.3-.05.44-.22.98-.44,1.97-.66,2.95-.62,2.78-1.27,5.65-1.97,8.43l-.02.05c-.19.75-.75,1.09-1.06,1.23-.57.26-1.21.24-1.76-.05l-.36-.18c-.9-.47-1.31-1.55-.95-2.53,5.3-14.45.41-29.88-12.16-38.42-.83-.56-1.1-1.67-.63-2.58l.18-.35c.27-.52.74-.88,1.31-1.03.16-.04.32-.06.49-.06.41,0,.82.13,1.17.38,1.68,1.2,3.31,2.39,4.76,3.75,6.66,6.22,10.47,13.96,11.33,23.04.05.53.18,1.03.29,1.46l.03.1c.05.16.07.33.07.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.05,58.26c-.17.2-.65.64-1.42.51l-2.07-.35c-2.08-.35-4.18-.72-6.29-1.04-1.86-.29-3.73-.55-5.59-.77-1.4-.16-2.81-.29-4.21-.38-2.31-.16-4.61-.21-6.91-.21-3.09,0-6.2.1-9.42.21-2.04.07-8.23,1.16-10.35,1.2l-.84-2.68-1.3-4.12-.96-3.04-1.29-4.12-.8-2.53-1.3-4.12-.96-3.04-1.29-4.12-.47-1.47c.78-.53,1.57-1.05,2.35-1.56.95-.62,5.59-2.55,6.52-3.15,1.17-.77,3.46-1.8,4.6-2.56,3.43-2.26,5.97-3.97,9.13-6.51.09-.07.18-.15.27-.22,2.18-1.77,4.28-3.66,6.33-5.59,1.83-1.73,3.62-3.49,5.38-5.22l1.54-1.52c.56-.55,1.21-.46,1.46-.4.25.07.86.29,1.09,1.03l2.15,6.83,4.85,15.4,10.09,32.08c.24.74-.13,1.28-.31,1.47Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.44,82.95c.72.74.61,2-.29,2.5-.06.03-.12.06-.18.09-1.27.5-2.57.95-3.88,1.38-1.73.57-3.48,1.09-5.19,1.6l-1.31.39c-2.67.8-3.97.37-5.55-1.82-.04-.06-.08-.11-.12-.16-1.21-1.69-2.42-3.39-3.63-5.09-.98-1.37-1.95-2.76-2.92-4.12-.61-.86-1.21-1.71-1.81-2.56l-.34-.48-1.94-2.74c1.43-.46,2.86-.91,4.3-1.37,2.88-.92,5.78-1.85,8.71-2.78l.79-.26h.42c.49.73.96,1.44,1.44,2.16.19.29.38.58.58.87.91,1.37,1.85,2.76,2.82,4.12.61.85,1.24,1.7,1.89,2.53.14.17.28.34.42.51.95,1.07,2.04,1.97,3.12,2.85.53.43,1.03.84,1.51,1.27.2.18.4.37.6.56l.08.07c.13.12.31.3.5.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.5,67.52h-.42l.35-.11s.05.08.08.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.63,37.79c-.19.58-.61,1.03-1.18,1.27-.57.24-1.22.21-1.77-.08l-.07-.03c-.89-.47-1.33-1.49-1.04-2.45,1.19-3.93,1.2-7.83,0-11.56-1.21-3.78-3.41-6.93-6.54-9.34-.84-.64-1.1-1.76-.62-2.66l.04-.08c.29-.55.77-.93,1.37-1.06.16-.04.33-.06.5-.06.42,0,.84.13,1.2.39,6.61,4.73,11.52,15.06,8.11,25.67Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertisments);
export default __webpack_public_path__ + "static/media/Advertisments.454a3f5f79a6de412baf0bae0ce3fc36.svg";
export { ForwardRef as ReactComponent };